module.exports = __webpack_public_path__ + "images/label-payment-5723bf941548edbeb5dfa325762a7d8d.png";